import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';

import { PresentationModalComponent } from '../presentation-modal/presentation-modal.component';
import { socialAppSelectors } from '../state/app';

@Injectable({
  providedIn: 'root',
})
export class PerformerSelectorService extends Loggable implements OnDestroy {
  private overlay = inject(Overlay);
  private store = inject(Store);

  private overlayRef?: OverlayRef;
  private portalRef?: ComponentPortal<PresentationModalComponent>;
  private ref?: ComponentRef<PresentationModalComponent>;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    super();
    this.store
      .select(socialAppSelectors.isRoomOpen)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isRoomOpen) => {
        if (!isRoomOpen) {
          this.close();
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public open(): Subject<boolean> {
    this.overlayRef = this.overlay.create({
      width: '100%',
      height: '100%',
    });
    this.portalRef = new ComponentPortal<PresentationModalComponent>(PresentationModalComponent);
    this.ref = this.overlayRef.attach(this.portalRef);
    this.ref.instance.closed.subscribe((value) => {
      if (value) {
        this.close();
      }
    });
    return this.ref.instance.closed;
  }

  public close(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.portalRef = undefined;
      this.overlayRef = undefined;
      this.ref = undefined;
    }
  }
}
